import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { TmLanguageSelectComponent } from "@teammood/shared/ui/language-select";
import { TmTimepickerComponent } from "@teammood/shared/ui/timepicker";
import { TmTimeZonePickerComponent } from "@teammood/shared/ui/timezone-picker";
import { TmWorkingDaysComponent, WorkingDays } from "@teammood/shared/ui/working-days";
import { Team, TeamSettings } from "@teammood/team";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { debounceTime, tap, distinctUntilChanged } from "rxjs";
import { TmValidators } from '@teammood/shared/util/form';


@Component({
    selector: 'team-defaults-settings-form',
    templateUrl: './team-defaults-settings-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        TmLanguageSelectComponent,
        TmTimeZonePickerComponent,
        TmTimepickerComponent,
        TmWorkingDaysComponent,
        TranslateModule
    ]
})
export class TeamDefaultsSettingsFormComponent {
  private _mode: "create" | "update";
  
  @Input()
  set team(team: Team) {
    this.form.reset(team, { emitEvent: false });
  }

  @Input()
  set mode(mode: 'create' | 'update') {
    this._mode = mode;
    if (mode === 'create') {
      this.form.get('name').addValidators([TmValidators.required, Validators.minLength(2)]);
    }
  }

  get mode() {
    return this._mode;
  }

  get name() {
    return this.form.get('name');
  }
  
  @Output()
  onUpdate = new EventEmitter<TeamSettings>();

  constructor() {
    this.form.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap(() => this.onUpdate.emit(this.form.getRawValue() as TeamSettings)),
        takeUntilDestroyed()
      )
      .subscribe();
  }

  form = new FormGroup({
    name: new FormControl<string>('', [TmValidators.required]),
    moodsDisplayTime: new FormGroup({
      timeZone: new FormControl<string>(''),
      time: new FormControl<string>(''),
    }),
    notificationTime: new FormGroup({
      timeZone: new FormControl<string>(''),
      time: new FormControl<string>(''),
    }),
    workingDays: new FormControl<WorkingDays>(null),
    language: new FormControl<string>(''),
  })
}